import router from '@/router'
import { useUserStore } from '@/store/user'
import { createRequest } from './createRequest'

/**
 * admin 后台请求器。共性逻辑见 createRequest.ts。
 *
 * 只在 admin 域内才跳 /admin/login; 若当前在 portal 前台, 仅 logout 清 token,
 * 不强行把用户拉到后台登录页 (portal 有自己的 /login, 由 request-mp.ts 处理)。
 * 这防止了 "portal 页面误调 admin API → 401 → 用户被拉到 admin 登录页" 的串域跳转。
 */
export const request = createRequest({
  baseURL: '/api/admin',
  getToken: () => useUserStore().token,
  logout: () => useUserStore().logout(),
  redirectToLogin: () => {
    const currentPath = router.currentRoute.value.path
    const isAdminArea = currentPath.startsWith('/admin') && currentPath !== '/admin/login'
    if (isAdminArea) {
      const target = router.currentRoute.value.fullPath
      router.push({ path: '/admin/login', query: { redirect: target } })
    }
  },
  // admin: 403 走通用错误提示, 不登出 (与历史行为一致)
  treat403AsAuthFailure: false,
  networkErrorMessage: (error) =>
    ((error.response?.data as Record<string, unknown>)?.message as string) ||
    error.message ||
    '网络错误'
})

export default request
